import React from 'react';
import { ThemeProvider } from './context/ThemeContext';

export const ThemeRoot: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider>
    {children}
  </ThemeProvider>
);

export { ThemeButton } from './components/ThemeButton';